<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">

  <mat-button-toggle-group [formControl]="viewGroup">
    <mat-button-toggle value="listView">
      <fa-icon icon="list"></fa-icon>
    </mat-button-toggle>
    <mat-button-toggle value="treeView">
      <fa-icon icon="sitemap"></fa-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div #buttonCreateOffice class="in-block">
    <button mat-raised-button color="primary" [routerLink]="['create']" *mifosxHasPermission="'CREATE_OFFICE'">
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      Create Office
    </button>
  </div>

  <div #buttonImportOffices class="in-block">
    <button mat-raised-button color="primary" *mifosxHasPermission="'CREATE_OFFICE'"
      [routerLink]="['/organization', 'bulk-import', 'Offices']">
      <fa-icon icon="upload" class="m-r-10"></fa-icon>
      Import Offices
    </button>
  </div>

</div>

<div class="container" [hidden]="viewGroup.value !== 'listView'">

  <div fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <mat-label>{{ 'Filter'| translate}}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>

  <!-- List View -->
  <div class="mat-elevation-z8">

    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{' Office Name '|translate}}</th>
        <td mat-cell *matCellDef="let offices"> {{ offices.name }} </td>
      </ng-container>

      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{' External ID '|translate}}</th>
        <td mat-cell *matCellDef="let offices"> {{ offices.externalId }} </td>
      </ng-container>

      <ng-container matColumnDef="parentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{' Parent Office '|translate}}</th>
        <td mat-cell *matCellDef="let offices"> {{ offices.parentName }} </td>
      </ng-container>

      <ng-container matColumnDef="openingDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{' Opened On '|translate}}</th>
        <td mat-cell *matCellDef="let offices"> {{ offices.openingDate | dateFormat }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="select-row"
        [routerLink]="[row.id, 'general']"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>

  </div>
</div>

<!-- Tree View -->
<div class="container" [hidden]="viewGroup.value !== 'treeView'">

  <div class="m-b-20" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="20px">
    <button mat-raised-button (click)="nestedTreeControl.expandAll()">
      {{'Expand All'|translate}}
    </button>
    <button mat-raised-button (click)="nestedTreeControl.collapseAll()">
      {{'Collapse All'|translate}}
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="4%" fxLayout.lt-md="column">

    <div fxFlex>

      <mat-card>

        <mat-card-content>

          <mat-tree [dataSource]="nestedTreeDataSource" [treeControl]="nestedTreeControl" class="office-tree">

            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
              <li class="mat-tree-node">
                <button mat-icon-button disabled></button>
                <span (click)="viewOfficeNode(node)" class="m-r-10">
                  {{ node.name }}
                </span>
              </li>
            </mat-tree-node>

            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
              <li>
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                    <fa-icon class="mat-icon-rtl-mirror"
                      icon="{{ nestedTreeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right' }}"></fa-icon>
                  </button>
                  <span (click)="viewOfficeNode(node)" class="m-r-10">
                    {{ node.name }}
                  </span>
                </div>
                <ul [class.office-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </mat-nested-tree-node>

          </mat-tree>

        </mat-card-content>

      </mat-card>

    </div>

    <div fxFlex="48%" *ngIf="office">

      <mat-card>

        <mat-card-content>

          <div fxLayout="row">

            <mat-card-title>
              {{ office.name }}
            </mat-card-title>

            <div fxFlex fxLayoutAlign="end">
              <button mat-icon-button (click)="closeOffice()">
                <fa-icon icon="times"></fa-icon>
              </button>
            </div>

          </div>

          <mat-tab-group>

            <mat-tab label="General">

              <div fxLayout="row wrap" class="content">

                <div fxFlex="50%" class="mat-body-strong" *ngIf="office.parentId">
                  {{'Parent Office'|translate}}
                </div>

                <div fxFlex="50%" *ngIf="office.parentId">
                  {{ office.parentName }}
                </div>

                <div fxFlex="50%" class="mat-body-strong">
                 {{' Opened On'|translate}}
                </div>

                <div fxFlex="50%">
                  {{ office.openingDate | date }}
                </div>

                <div fxFlex="50%" class="mat-body-strong" *ngIf="office.externalId">
                  {{'External ID'|translate}}
                </div>

                <div fxFlex="50%" *ngIf="office.externalId">
                  {{ office.externalId }}
                </div>

              </div>

            </mat-tab>

            <mat-tab *ngFor="let dataTable of dataTablesData" label="{{ dataTable.registeredTableName }}"></mat-tab>

          </mat-tab-group>

        </mat-card-content>

      </mat-card>

    </div>

  </div>

</div>

<ng-template #templateButtonTreeView let-popover="popover">
  <h2>Tree View</h2>
  <p class="mw300">This will launch an alternative view which allows you to view the office hierarchy for your
    organization.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn"
      (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();previousStep();">Back</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateButtonCreateOffice,buttonCreateOffice,'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateButtonCreateOffice let-popover="popover">
  <h2>Create Office</h2>
  <p class="mw300">This option allows you to create new offices in your organization.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn"
      (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateButtonTreeView,buttonTreeView,'bottom', true);">Back</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateButtonImportOffices,buttonImportOffices,'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateButtonImportOffices let-popover="popover">
  <h2>Import Offices</h2>
  <p class="mw300">This will launch the Bulk import/Offices page.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn"
      (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateButtonCreateOffice,buttonCreateOffice,'bottom', true);">Back</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateFilter,filter,'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateFilter let-popover="popover">
  <h4>Search bar to filter offices.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn"
      (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateButtonImportOffices,buttonImportOffices,'bottom', true);">Back</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateTableOffices,tableOffices,'top', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateTableOffices let-popover="popover">
  <h4>List of offices in the organization.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn"
      (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary"
      (click)="popover.close();showPopover(templateFilter,filter,'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();nextStep()">Next</button>
  </div>
</ng-template>
